<div class="edit-page-root-container discount-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                    @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                    }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                          <mat-tab-group animationDuration="0ms" style="width:100%;" dynamicHeight>
              <mat-tab label="GENERAL" style="overflow: hidden;">
                         <div class="input-group code-and-name-div">
                            <div class="input-box-left"> 
                                <mat-form-field class="code">
                                <mat-label>Code</mat-label>
                                <input matInput formControlName="code" maxlength="50"
                                    [readonly]="discountInfo.id!==undefined && discountInfo.id!==0">
                                <mat-error *ngIf="editForm.controls['code'].hasError('required')">Discount code should be
                                    entered</mat-error>
                                <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                    50.</mat-error>
                            </mat-form-field>
                            </div>

                            <div class="input-box-right">  <mat-form-field class="name">
                                <mat-label>Name</mat-label>
                                <input matInput formControlName="name">
                                <mat-error *ngIf="editForm.controls['name'].hasError('required')">Discount name should be
                                    entered</mat-error>
                                <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                    100.</mat-error>
                            </mat-form-field></div>

                        </div>
                         <mat-form-field class="description">
                  <mat-label>Description</mat-label>
                  <textarea matInput formControlName="description"></textarea>
                  <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length is
                    200.</mat-error>
                </mat-form-field>

                        <div class="input-box-right" style="display: flex; gap: 25px;">
                          <mat-form-field class="flex">
                            <mat-label>Permitted For</mat-label>
                            <mat-select formControlName="permitted_for" required [disabled]="editForm.get('is_item_specific')?.value">
                              <mat-option [value]="null" disabled *ngIf="!editForm.get('permitted_for')?.value">Select</mat-option>
                              <mat-option [value]="1">
                                Item Discount
                              </mat-option>
                              <mat-option [value]="2">
                                Bill Discount
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field class="flex">
                            <mat-label>Allow Editing</mat-label>
                            <mat-select formControlName="allow_editing" required>
                              <mat-option [value]="null" disabled *ngIf="editForm.get('allow_editing')?.value === null || editForm.get('allow_editing')?.value === undefined">Select</mat-option>
                              <mat-option [value]="0">
                                None
                              </mat-option>
                              <mat-option [value]="1">
                                Unit Price
                              </mat-option>
                              <mat-option [value]="2">
                                Net Price
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>

                 <div class="input-box-right" style="display: flex; gap: 25px;">
                  <mat-form-field class="color-chooser fg-color" class="flex">
                    <mat-label>BG color</mat-label>
                    <input matInput type="color" formControlName="bg_color">
                  </mat-form-field>

                  <mat-form-field class="color-chooser fg-color" class="flex">
                    <mat-label>FG color</mat-label>
                    <input matInput type="color" formControlName="fg_color">
                  </mat-form-field>
                  <mat-form-field class="name" class="flex">
                    <mat-label>Account number</mat-label>
                    <input matInput formControlName="account_code">

                  </mat-form-field>
                </div>
                 <div *ngIf="shouldShowDiscountSection()" class="input-box-right"
                  style="display: flex;flex-direction: row; gap:30px;">
                  <mat-form-field class="grouping-quantity flex" *ngIf="shouldShowPromotionAndGroupingFields()">
                    <mat-label>Grouping Quantity</mat-label>
                    <input matInput type="number" formControlName="grouping_quantity">
                  </mat-form-field>
                  <mat-form-field class="discount flex" *ngIf="shouldShowDiscountField()">
                    <mat-label>Discount</mat-label>
                    <input matInput formControlName="price">
                    <mat-error *ngIf="editForm.controls['price'].hasError('required')">Discount is required</mat-error>
                  </mat-form-field>
                  <!-- <mat-checkbox ormControlName="is_percentage"></mat-checkbox>
                Percentage -->

                  <mat-button-toggle-group formControlName="is_percentage" class="offer-percentage-option-grp">
                    <mat-button-toggle [value]="1">%</mat-button-toggle>
                    <mat-button-toggle [value]="0">$</mat-button-toggle>
                  </mat-button-toggle-group>

                  <div>
                    <mat-checkbox formControlName="is_overridable"> Overridable</mat-checkbox>

                  </div>

                </div>
                 
             <div>
                  <div class="input-box" style="display: flex; gap: 25px;">
                  <mat-form-field class="flex">
                    <mat-label>Date From</mat-label>
                    <input matInput [matDatepicker]="pickerFrom" formControlName="date_from" placeholder="DD-MM-YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerFrom></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field class="flex">
                    <mat-label>Date To</mat-label>
                    <input matInput [matDatepicker]="pickerTo" formControlName="date_to"
                      [min]="editForm.get('date_from')?.value" placeholder="DD-MM-YYYY" />
                    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                    <mat-datepicker #pickerTo></mat-datepicker>
                  </mat-form-field>
                </div>
                  <mat-checkbox formControlName="is_promotion" *ngIf="shouldShowPromotionAndGroupingFields()">promotion</mat-checkbox>
                   <div class="time-and-day-div" *ngIf="editForm.get('is_promotion')?.value && shouldShowPromotionAndGroupingFields()">
                      <div class="flex space-x-4 mb-4">

                    <!-- Time From -->
                    <div class="flex-1">
                      <label class="block text-gray-700 mb-1" style="margin-bottom: 20px;
    display: block;
    margin-top: 10px;">Time From</label>
                      <div class="flex space-x-2">
                        <!-- Hour Select -->
                        <mat-form-field appearance="outline" class="w-20" style="width: 120px; font-size: 12px;">
                          <mat-label>Hour</mat-label>
                          <mat-select formControlName="time_from_hour">
                            <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
                          </mat-select>
                        </mat-form-field>

                        <!-- Colon -->
                        <span class="self-center pt-4">:</span>

                        <!-- Minute Select -->
                        <mat-form-field appearance="outline" class="w-20" style="width: 120px; font-size: 12px;">
                          <mat-label>Minute</mat-label>
                          <mat-select formControlName="time_from_minute">
                            <mat-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>

                    <!-- Time To -->
                    <div class="flex-1">
                      <label class="block text-gray-700 mb-1" style="margin-bottom: 20px;display: block;margin-top: 10px;">Time To</label>
                      <div class="flex space-x-2">
                        <!-- Hour Select -->
                        <mat-form-field appearance="outline" class="w-20" style="width: 120px; font-size: 12px;">
                          <mat-label>Hour</mat-label>
                          <mat-select formControlName="time_to_hour">
                            <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
                          </mat-select>
                        </mat-form-field>

                        <!-- Colon -->
                        <span class="self-center pt-4">:</span>

                        <!-- Minute Select -->
                        <mat-form-field appearance="outline" class="w-20" style="width: 120px; font-size: 12px;">
                          <mat-label>Minute</mat-label>
                          <mat-select formControlName="time_to_minute">
                            <mat-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>

                  </div>
                   <div class="input-group days">
              <div class="input-box-left">
                <div class="day">Day</div>
              </div>
              <div class="input-box-right" formGroupName="week_days">
                <mat-checkbox *ngFor="let day of daysOfWeek" [formControlName]="day" class="day-checkbox">
                  {{ day }}
                </mat-checkbox>
              </div>
            </div>
                   </div>
              
                  <mat-checkbox formControlName="is_valid">valid</mat-checkbox>
                </div>
            </mat-tab>
              <mat-tab label="ITEMS" [disabled]="shouldDisableItemsTab()" style="overflow: hidden;">
 <div style="display: flex;justify-content: space-between;padding-top: 20px;">
                  <mat-checkbox formControlName="is_item_specific"> Item specific
                  </mat-checkbox>
                  <button mat-flat-button class="action-btn btn-add" *ngIf="editForm.get('is_item_specific')?.value"
                    (click)="openSaleItemBrowseDialog()">ADD</button>

                </div>

                              <table mat-table [dataSource]="dataSource" *ngIf="editForm.get('is_item_specific')?.value">

                  <!-- Sale Item Code Column -->
                  <ng-container matColumnDef="sale_item_code">
                    <th mat-header-cell *matHeaderCellDef style="width: 100px;"> Item Code </th>
                    <td mat-cell *matCellDef="let item" style="width: 100px;"> {{ item.sale_item_code }} </td>
                  </ng-container>

                  <!-- Sale Item Name Column -->
                  <ng-container matColumnDef="sale_item_name">
                    <th mat-header-cell *matHeaderCellDef> Item Name </th>
                    <td mat-cell *matCellDef="let item"> {{ item.sale_item_name }} </td>
                  </ng-container>

                  <!-- Price Column -->
                  <!-- <ng-container matColumnDef="price">
    <th mat-header-cell *matHeaderCellDef class="status-header"> Discount</th>
    <td mat-cell *matCellDef="let item" style="text-align: right;"> {{ item.price }} </td>
  </ng-container> -->
                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef>Discount</th>
                    <td mat-cell *matCellDef="let item">

                      <input class="discount-input" matInput type="number" [value]="item.price"
                        (input)="item.price = $any($event.target).value"
                        style="width: 80px; text-align: right; padding: 6px; border-radius: 4px;" />
                    </td>
                  </ng-container>


                  <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef></th>

                    <td mat-cell *matCellDef="let element" style="text-align: right;">
                    
                      <mat-icon class="close-button"
                        (click)="onDeleteSaleItem(element.sale_item_id)">delete_forever</mat-icon>
                    </td>
                  </ng-container>

                  <!-- Header and Row Declarations -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>


               

              </mat-tab>
            </mat-tab-group>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
